const baseURL = "/v1/Formacao";

const service = {
  methods: {
    $buscar(params) {
      return this.$api().get(`${baseURL}/ListaDePresenca`, params);
    },
    $editar(body, id) {
      return this.$api().put(`${baseURL}/ListaDePresenca/${id}`, body);
    },
    $visualizar(id) {
      return this.$api().get(`${baseURL}/ListaDePresenca/${id}`);
    },
    $obterListaPresencaCSV(id) {
      return this.$api().get(`${baseURL}/BaixarListaDePresencaCsv/${id}`);
    },
    $obterListaPresencaPDF(params) {
      return this.$api().get(`${baseURL}/BaixarListaDePresencaPdf`, this.$getParamsObject(params));
    },
    $obter(cpf) {
      return this.$api().get(`${baseURL}/ObterUsuarioPresenca/${cpf}`);
    },
    $marcarPresenca(id, body) {
      return this.$api().patch(`${baseURL}/ListaDePresenca/${id}/MarcarPresenca`, body);
    },
  },
};

export default service;